module.exports = __webpack_public_path__ + "img/奖项名称.ee7f11b4.png";